import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { frame: String };
  declare readonly hasFrameValue: boolean;
  declare readonly frameValue: string;

  connect() {
  }

  changeLength = e => {
    const val = e.target.value;
    if (!val?.length) return;
    if (this.hasFrameValue) {
      const frame = document.querySelector(`turbo-frame[id="${this.frameValue}"]`);
      frame.setAttribute('src', val);
    }
    else Turbo.visit(val);
  }
}
